import { merge } from "lodash"
import defaultConfig from "./configuration/default"

export default {
  materialType: "tyosuhdeasioiden-kasikirja",
  languages: [
    "fi",
    "sv",
  ],
  title: "label.tyosuhdeasioidenKasikirja",
  description: "description.tyosuhdeasioidenKasikirja",
  configuration: merge({}, defaultConfig, {
    listing: {
      caption: true,
      title: true,
      type: true,
    },
  }),
}
